// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer__reset[data-v-057befa2] {\n  left: 1rem;\n}\n.notifications[data-v-057befa2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  overflow: scroll;\n}\n.notifications p[data-v-057befa2] {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
